import { Badge, Button, Flex, SegmentedControl } from '@mantine/core';
import { ViewsTypesEnum } from '@worker/types/myJobs.type';
import { GoGear } from 'react-icons/go';
import { FiCheck } from 'react-icons/fi';
import { useWorkerStore } from '@worker/stores';

interface HeaderProps {
  value: ViewsTypesEnum;
  handleChangeView: (value: ViewsTypesEnum) => void;
  handleGetInNetwork: () => void;
  handleConfigure: () => void;
}

function Header({
  value,
  handleChangeView,
  handleGetInNetwork,
  handleConfigure,
}: HeaderProps) {
  const { isInNetwork } = useWorkerStore();
  return (
    <Flex gap="md">
      <Flex gap="md" justify="space-between" align="center" flex={1}>
        <SegmentedControl
          size="md"
          data={[
            { label: 'All Jobs', value: ViewsTypesEnum.ALL_PUBLIC_JOBS },
            { label: 'My Jobs', value: ViewsTypesEnum.MY_JOBS },
          ]}
          value={value}
          onChange={(view) => handleChangeView(view as ViewsTypesEnum)}
        />
        <Flex gap="md">
          {isInNetwork() ? (
            <Badge
              size="xl"
              variant="verified"
              leftSection={<FiCheck size={18} color="var(--green)" />}
              onClick={handleGetInNetwork}
              style={{ cursor: 'pointer' }}
            >
              IN-NETWORK VERIFIED
            </Badge>
          ) : (
            <Button onClick={handleGetInNetwork}>Get in-network</Button>
          )}
          <Button
            rightSection={<GoGear size={20} />}
            onClick={handleConfigure}
            variant="light"
          >
            Configure
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default Header;
